import { utils, writeFile } from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "sonner";

const ts = () => new Date().toISOString().slice(0, 10);

/**
 * columns: [{ key, label, format?: (val, row) => string }]
 * rows: array of row objects
 */
export function exportXLSX(rows, columns, filename) {
  try {
    const data = rows.map((r) => {
      const o = {};
      columns.forEach((c) => { o[c.label] = c.format ? c.format(r[c.key], r) : (r[c.key] ?? ""); });
      return o;
    });
    const ws = utils.json_to_sheet(data);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Data");
    writeFile(wb, `${filename}-${ts()}.xlsx`);
    toast.success("Export Excel berhasil");
  } catch (e) {
    toast.error("Export gagal");
  }
}

export function exportCSV(rows, columns, filename) {
  try {
    const header = columns.map((c) => `"${c.label.replace(/"/g,'""')}"`).join(",");
    const body = rows.map((r) => columns.map((c) => {
      const v = c.format ? c.format(r[c.key], r) : (r[c.key] ?? "");
      return `"${String(v).replace(/"/g, '""')}"`;
    }).join(",")).join("\n");
    const csv = header + "\n" + body;
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `${filename}-${ts()}.csv`; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
    toast.success("Export CSV berhasil");
  } catch (e) { toast.error("Export gagal"); }
}

export function exportPDF(rows, columns, title, filename) {
  try {
    const doc = new jsPDF({ orientation: "landscape", unit: "pt" });
    doc.setFontSize(14);
    doc.setTextColor("#083B1E");
    doc.text("Flight Operation Division Portal", 40, 40);
    doc.setFontSize(11);
    doc.setTextColor("#0F172A");
    doc.text(title, 40, 60);
    doc.setFontSize(9);
    doc.setTextColor("#64748b");
    doc.text(`Dicetak: ${new Date().toLocaleString("id-ID")}`, 40, 75);

    autoTable(doc, {
      startY: 90,
      head: [columns.map((c) => c.label)],
      body: rows.map((r) => columns.map((c) => c.format ? c.format(r[c.key], r) : (r[c.key] ?? ""))),
      styles: { fontSize: 8, cellPadding: 4 },
      headStyles: { fillColor: [0, 166, 81], textColor: 255, fontStyle: "bold" },
      alternateRowStyles: { fillColor: [240, 253, 244] },
      margin: { left: 40, right: 40 },
    });
    doc.save(`${filename}-${ts()}.pdf`);
    toast.success("Export PDF berhasil");
  } catch (e) {
    console.error(e);
    toast.error("Export gagal");
  }
}
